"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var classNames = require("classnames");
var Slider = /** @class */ (function (_super) {
    __extends(Slider, _super);
    function Slider(props) {
        var _this = _super.call(this, props) || this;
        _this.updatePositionOnResize = function () {
            _this.updatePosition();
        };
        _this.updatePosition = function (props) {
            props = props || _this.props;
            var value = props.value, min = props.min, max = props.max;
            var positionObj = _this.slider.getBoundingClientRect();
            var left = positionObj.left, width = positionObj.width;
            var positionHandler = _this.valueToPosition(value, min, max, width);
            _this.setState({
                positionHandler: positionHandler,
                left: left,
                width: width
            });
        };
        _this.handleClick = function (event) {
            _this.handleValueOnChange(event);
        };
        _this.handleDragStart = function () {
            _this.setState({ isDragging: true });
        };
        _this.handleDragEnd = function () {
            _this.setState({ isDragging: false });
        };
        _this.handleMouseMove = function (event) {
            var isDragging = _this.state.isDragging;
            if (!isDragging) {
                return;
            }
            _this.handleValueOnChange(event);
        };
        _this.handleValueOnChange = function (event) {
            var width = _this.state.width;
            var _a = _this.props, min = _a.min, max = _a.max, onChange = _a.onChange;
            var pageX = event.pageX;
            var value = _this.positionToValue(pageX, min, max, width);
            if (value < min) {
                value = min;
            }
            if (value > max) {
                value = max;
            }
            onChange(value);
        };
        _this.valueToPosition = function (value, min, max, width) {
            if (value < min || value > max) {
                throw Error('Invalid value provided. The value must be a number between `min` and `max`');
            }
            var handlerPosition = width * (value / (max - min)) - 8;
            return handlerPosition;
        };
        _this.positionToValue = function (position, min, max, width) {
            var sliderLeftBorder = _this.slider.getBoundingClientRect().left;
            return (max - min) * ((position - sliderLeftBorder) / width);
        };
        _this.state = {
            isDragging: false,
            positionHandler: 0,
            positionMask: 0
        };
        // Attach event listeners
        document.addEventListener('mousemove', _this.handleMouseMove);
        document.addEventListener('mouseup', _this.handleDragEnd);
        return _this;
    }
    Slider.prototype.componentDidMount = function () {
        // Calculate component position
        this.updatePosition();
        window.addEventListener('resize', this.updatePositionOnResize);
    };
    Slider.prototype.componentWillReceiveProps = function (newProps) {
        this.updatePosition(newProps);
    };
    Slider.prototype.componentDidUpdate = function () {
        var _a = this.props, value = _a.value, min = _a.min, max = _a.max;
        var positionObj = this.slider.getBoundingClientRect();
        var left = positionObj.left, width = positionObj.width;
        if (left !== this.state.left || width !== this.state.width) {
            this.updatePosition();
        }
    };
    Slider.prototype.componentWillUnmount = function () {
        // Detach event listeners
        document.removeEventListener('mousemove', this.handleMouseMove);
        document.removeEventListener('mouseup', this.handleDragEnd);
        window.removeEventListener('resize', this.updatePositionOnResize);
    };
    Slider.prototype.render = function () {
        var _this = this;
        var _a = this.state, positionHandler = _a.positionHandler, isDragging = _a.isDragging;
        var _b = this.props, disabled = _b.disabled, className = _b.className, style = _b.style;
        var grabbingClassName = classNames('form-control__slider-handler', {
            'form-control__slider-handler--grabbing': isDragging
        });
        var sliderClassName = classNames('form-control__slider', {
            'form-control__slider--disabled': disabled
        }, className);
        return (React.createElement("div", { className: sliderClassName, style: style, ref: function (slider) {
                _this.slider = slider;
            }, onClick: this.handleClick },
            React.createElement("div", { className: "form-control__slider-mask", style: { width: positionHandler + 8 } }),
            React.createElement("div", { className: grabbingClassName, onMouseDown: this.handleDragStart, style: { left: positionHandler } })));
    };
    Slider.defaultProps = {
        min: 0,
        max: 100,
        value: 0
    };
    return Slider;
}(React.Component));
exports.default = Slider;
//# sourceMappingURL=Slider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/components/Slider/Slider.js
// module id = 277
// module chunks = 0